import React from "react";
import PageWrapper from "./viewClient.style";
import { connect } from "react-redux";
import ClientViewDetails from "../../components/viewclient/ClientViewDetails";
import PageTitle from "components/common/PageTitle";

const ViewClientDetail = props => {
  return (
    <PageWrapper {...props}>
      <div className="pos-relative">
        <PageTitle
          props={props}
          title="sidebar.client_management"
          className="plr-15"
          breadCrumb={[
            {
              name: "sidebar.dashboard",
              url: "/dashboard"
            },
            {
              name: "sidebar.client_management",
              url: "/client"
            },
            {
              name: "action.view"
            }
          ]}
        />
        <div
          className="back-icon fs-15 demi-bold-text cursor-pointer"
          onClick={() => props.history.push("/client")}
        >
          <i className="fas fa-step-backward"></i> Back
        </div>
      </div>
      <div className="user-tbl">
        <ClientViewDetails {...props} />
      </div>
    </PageWrapper>
  );
};

const mapStateToProps = state => {
  return {
    ...state.themeChanger,
    auth: state.auth
  };
};

export default connect(mapStateToProps, null)(ViewClientDetail);
